import React from "react";
import { useDropzone } from "react-dropzone";
import Papa from "papaparse";
import * as XLSX from "xlsx";

const CsvDropzone = ({ datos }) => {

  // 🔹 Normaliza cada fila (FIX trim)
  const normalizarFila = (row) => {
    const filaLimpia = {};

    Object.keys(row).forEach(col => {
      filaLimpia[col] = String(row[col] ?? "").trim();
    });

    return filaLimpia;
  };

  // 🔹 Procesa CSV
  const procesarCSV = (file) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const datosLimpios = results.data.map(normalizarFila);
        datos(datosLimpios);
      },
    });
  };

  // 🔹 Procesa Excel
  const procesarExcel = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      const json = XLSX.utils.sheet_to_json(sheet, {
        defval: "", // evita undefined
      });

      const datosLimpios = json.map(normalizarFila);
      datos(datosLimpios);
    };

    reader.readAsArrayBuffer(file);
  };

  // 🔹 Dropzone
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      "text/csv": [".csv"],
      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
    },
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (!file) return;

      const extension = file.name.split(".").pop().toLowerCase();

      if (extension === "csv") {
        procesarCSV(file);
      } else if (extension === "xls" || extension === "xlsx") {
        procesarExcel(file);
      } else {
        alert("Formato no soportado");
      }
    },
  });

  return (
    <div
      {...getRootProps()}
      style={{
        border: "2px dashed #1976d2",
        borderRadius: "8px",
        padding: "30px",
        textAlign: "center",
        cursor: "pointer",
        backgroundColor: isDragActive ? "#e3f2fd" : "#fafafa",
      }}
    >
      <input {...getInputProps()} />
      {isDragActive ? (
        <p>📂 Suelta el archivo aquí...</p>
      ) : (
        <p>
          Arrastrá un archivo <b>CSV o Excel</b> aquí <br />
          o hacé click para seleccionarlo
        </p>
      )}
    </div>
  );
};

export default CsvDropzone;
